import { Skeleton } from '@mui/material';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';

const SkeletonProductCard = () => {
  return (
    <>
      <WebOnly>
        <div className="w-full">
          <div className="w-full aspect-[504/378] rounded-16 bg-auxiliary-light-gray relative overflow-hidden">
            <Skeleton
              className="w-full h-full rounded-16 bg-auxiliary-light-gray relative overflow-hidden"
              variant="rectangular"
              sx={{
                height: '100%!important',
              }}
            />
          </div>
          <div className="w-full h-[20px] mt-16 mb-12">
            <Skeleton />
          </div>
          <div className="w-[60%] h-[16px]">
            <Skeleton />
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="w-full">
          <div className="w-full aspect-[186/223] bg-auxiliary-light-gray relative overflow-hidden">
            <Skeleton
              className="w-full h-full bg-auxiliary-light-gray relative overflow-hidden"
              variant="rectangular"
              sx={{
                height: '100%!important',
              }}
            />
          </div>
          <div className="w-full h-[14px] mt-10 mb-12">
            <Skeleton />
          </div>
          <div className="w-full h-[14px]">
            <Skeleton />
          </div>
        </div>
      </WapOnly>
    </>
  );
};

export default SkeletonProductCard;
